/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GuestUserResponse } from '../models/GuestUserResponse';
import type { PaginatedResponse_UserResponse_ } from '../models/PaginatedResponse_UserResponse_';
import type { PasswordResetRequest } from '../models/PasswordResetRequest';
import type { PasswordResetResponse } from '../models/PasswordResetResponse';
import type { Roles } from '../models/Roles';
import type { TestEmailLoginRequest } from '../models/TestEmailLoginRequest';
import type { UserCreateFromContractorUserInviteRequest } from '../models/UserCreateFromContractorUserInviteRequest';
import type { UserCreateFromGuestInviteRequest } from '../models/UserCreateFromGuestInviteRequest';
import type { UserNotificationRequest } from '../models/UserNotificationRequest';
import type { UserNotificationResponse } from '../models/UserNotificationResponse';
import type { UserPreferredLanguageRequest } from '../models/UserPreferredLanguageRequest';
import type { UserRequest } from '../models/UserRequest';
import type { UserResponse_Output } from '../models/UserResponse_Output';
import type { UserTokenResponse } from '../models/UserTokenResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserRoutesRepository {
  /**
   * Get User Notifications
   * Returns current user notifications.
   * @returns UserNotificationResponse Successful Response
   * @throws ApiError
   */
  public static userRoutesGetUserNotifications({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<Array<UserNotificationResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/users/notifications',
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update User Notifications
   * Updates current user notifications.
   * @returns UserNotificationResponse Successful Response
   * @throws ApiError
   */
  public static userRoutesUpdateUserNotifications({
    requestBody,
    authorization,
  }: {
    requestBody: Array<UserNotificationRequest>,
    authorization?: string,
  }): CancelablePromise<Array<UserNotificationResponse>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/users/notifications',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Me User
   * Returns user self user.
   * @returns UserResponse_Output Successful Response
   * @throws ApiError
   */
  public static userRoutesGetMeUser({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<UserResponse_Output> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/users/me',
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Me Preferred Language
   * Updates the current user's preferred language. Open to guests, who can't use the general user update.
   * @returns UserResponse_Output Successful Response
   * @throws ApiError
   */
  public static userRoutesUpdateMePreferredLanguage({
    requestBody,
    authorization,
  }: {
    requestBody: UserPreferredLanguageRequest,
    authorization?: string,
  }): CancelablePromise<UserResponse_Output> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/users/me/preferred-language',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get All
   * Lists all users.
   * @returns PaginatedResponse_UserResponse_ Successful Response
   * @throws ApiError
   */
  public static userRoutesGetAll({
    roles,
    pageNumber = 1,
    perPage = 25,
    authorization,
  }: {
    /**
     * List of user roles
     */
    roles?: (Array<Roles> | null),
    pageNumber?: number,
    perPage?: number,
    authorization?: string,
  }): CancelablePromise<PaginatedResponse_UserResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/users',
      headers: {
        'authorization': authorization,
      },
      query: {
        'roles': roles,
        'page_number': pageNumber,
        'per_page': perPage,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get User
   * Returns user by id.
   * @returns UserResponse_Output Successful Response
   * @throws ApiError
   */
  public static userRoutesGetUser({
    id,
    authorization,
  }: {
    id: string,
    authorization?: string,
  }): CancelablePromise<UserResponse_Output> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/users/{id}',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update User
   * Updates a user by id.
   * @returns UserResponse_Output Successful Response
   * @throws ApiError
   */
  public static userRoutesUpdateUser({
    id,
    requestBody,
    authorization,
  }: {
    id: string,
    requestBody: UserRequest,
    authorization?: string,
  }): CancelablePromise<UserResponse_Output> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/users/{id}',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete User
   * Delete a user by id.
   * @returns void
   * @throws ApiError
   */
  public static userRoutesDeleteUser({
    id,
    authorization,
  }: {
    id: string,
    authorization?: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/users/{id}',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Check User Invite Is Valid
   * Checks if a given invite token is still valid, so UI can verify before displaying sign up form.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static userRoutesCheckUserInviteIsValid({
    token,
  }: {
    token: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/noauth/users/invite-is-valid/{token}',
      path: {
        'token': token,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create User From Contractor User Invite
   * Creates contractor user for given invite token.
   *
   * If the invited email belongs to an existing GUEST user (installer/homeowner),
   * this will promote them to a CONTRACTOR user and revoke any pending task invitations.
   * @returns UserResponse_Output Successful Response
   * @throws ApiError
   */
  public static userRoutesCreateUserFromContractorUserInvite({
    requestBody,
  }: {
    requestBody: UserCreateFromContractorUserInviteRequest,
  }): CancelablePromise<UserResponse_Output> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/noauth/users',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        409: `Conflict`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * User Password Reset
   * Sends out a password reset email to user created through email/password provider in GCP.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static userRoutesUserPasswordReset({
    email,
  }: {
    email: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/noauth/users/password-reset/{email}',
      path: {
        'email': email,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Check Password Reset Request Is Valid
   * Checks if a given password reset token is still valid, so UI can verify before displaying any form.
   * @returns PasswordResetResponse Successful Response
   * @throws ApiError
   */
  public static userRoutesCheckPasswordResetRequestIsValid({
    token,
  }: {
    token: string,
  }): CancelablePromise<PasswordResetResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/noauth/users/password-reset-request-is-valid/{token}',
      path: {
        'token': token,
      },
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Password Reset
   * Updates user password for a given token.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static userRoutesPasswordReset({
    requestBody,
  }: {
    requestBody: PasswordResetRequest,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/noauth/users/password-reset',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Authenticate Guest User From Invite
   * Authenticate guest user from invite token and return Firebase token.
   * @returns GuestUserResponse Successful Response
   * @throws ApiError
   */
  public static userRoutesAuthenticateGuestUserFromInvite({
    requestBody,
  }: {
    requestBody: UserCreateFromGuestInviteRequest,
  }): CancelablePromise<GuestUserResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/noauth/users/guest',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Test Email Login
   * Login for email login, this is to login for playwright tests.
   * @returns UserTokenResponse Successful Response
   * @throws ApiError
   */
  public static userRoutesTestEmailLogin({
    requestBody,
  }: {
    requestBody: TestEmailLoginRequest,
  }): CancelablePromise<UserTokenResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/noauth/users/test-email-login',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Test Guest Email Login
   * Login for guest email login, this is to login for playwright tests.
   * @returns UserTokenResponse Successful Response
   * @throws ApiError
   */
  public static userRoutesTestGuestEmailLogin({
    jobId,
    email,
  }: {
    jobId: string,
    email: string,
  }): CancelablePromise<UserTokenResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/noauth/users/test-guest-login/{job_id}/{email}',
      path: {
        'job_id': jobId,
        'email': email,
      },
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Email Event
   * Sendgrid Webhook.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static userRoutesEmailEvent({
    xTwilioEmailEventWebhookSignature,
    xTwilioEmailEventWebhookTimestamp,
  }: {
    xTwilioEmailEventWebhookSignature?: (string | null),
    xTwilioEmailEventWebhookTimestamp?: (string | null),
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/noauth/users/sendgrid/webhook',
      headers: {
        'x-twilio-email-event-webhook-signature': xTwilioEmailEventWebhookSignature,
        'x-twilio-email-event-webhook-timestamp': xTwilioEmailEventWebhookTimestamp,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
